module.exports = __webpack_public_path__ + "img/banner_1.e6a81c7c.png";